import ConfirmVirtualHelpdesk from '@/views/ConfirmVirtualHelpdesk/index.vue'

const ConfirmVirtualHelpdeskRouter = {
  path: '/confirm-virtual-helpdesk',
  name: 'ConfirmVirtualHelpdesk',
  component: ConfirmVirtualHelpdesk,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ConfirmVirtualHelpdeskRouter
